var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhonei = function SvgPhonei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M16.076 21a6.7 6.7 0 0 1-2.4-.514c-2.007-.782-3.7-2.234-5.793-4.324A22.6 22.6 0 0 1 3.58 10.42c-.918-1.909-.738-3.777.481-5l1.883-1.879a1.85 1.85 0 0 1 2.614 0l2.36 2.359a1.847 1.847 0 0 1 0 2.616l-1.1 1.1a6.37 6.37 0 0 0 1.851 2.759 6.3 6.3 0 0 0 2.761 1.845l1.1-1.1a1.83 1.83 0 0 1 1.306-.541 1.83 1.83 0 0 1 1.3.542l2.364 2.364a1.85 1.85 0 0 1 0 2.615l-1.879 1.879A3.46 3.46 0 0 1 16.076 21M7.252 4.583a.27.27 0 0 0-.188.077L5.181 6.543c-1.041 1.041-.468 2.578-.174 3.191a21.3 21.3 0 0 0 4 5.307 16.2 16.2 0 0 0 5.248 3.968c2 .783 2.814.289 3.252-.151l1.879-1.878a.27.27 0 0 0 .078-.189.26.26 0 0 0-.077-.187l-2.362-2.362a.26.26 0 0 0-.186-.077.26.26 0 0 0-.187.077l-1.369 1.368a.8.8 0 0 1-.49.229c-.28.022-1.858.035-4.24-2.346S8.178 9.544 8.2 9.253a.8.8 0 0 1 .229-.489L9.8 7.4a.26.26 0 0 0 .078-.188.26.26 0 0 0-.078-.19L7.438 4.66a.26.26 0 0 0-.186-.077"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhonei);
export default ForwardRef;